.screen {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  background-color: #14241a;
  background-image: var(--login-bg);
  background-size: cover;
  background-position: center;
  font-family: var(--token-font-body);
  color: var(--token-text-primary);
  overflow: hidden;
}

.tint {
  position: absolute;
  inset: 0;
  background: radial-gradient(
    120% 90% at 50% 30%,
    rgba(0, 0, 0, 0.05) 0%,
    rgba(0, 0, 0, 0.55) 100%
  );
  pointer-events: none;
}

.stack {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px;
  max-width: 560px;
  width: min(92vw, 560px);
}

.mascot {
  width: clamp(110px, 16vw, 160px);
  height: auto;
  filter: drop-shadow(0 18px 28px rgba(0, 0, 0, 0.45));
  margin-bottom: 0;
  user-select: none;
  -webkit-user-drag: none;
}

.card {
  position: relative;
  width: 100%;
  padding: 36px 32px 28px;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(22px) saturate(160%);
  -webkit-backdrop-filter: blur(22px) saturate(160%);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow:
    0 30px 60px -20px rgba(8, 18, 12, 0.55),
    0 12px 24px rgba(8, 18, 12, 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.6),
    inset 0 -1px 0 rgba(8, 18, 12, 0.08);
  color: #f7faf6;
  text-align: center;
}

.title {
  margin: 0 0 6px;
  font-family: var(--token-font-display);
  font-size: clamp(36px, 5vw, 52px);
  line-height: 1;
  letter-spacing: 0.5px;
  color: #fefdf6;
  text-shadow: 0 2px 14px rgba(0, 0, 0, 0.35);
}

.subtitle {
  margin: 0 0 22px;
  font-family: var(--token-font-ui);
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.92);
  letter-spacing: 0.2px;
}

.body {
  margin: 0 auto 18px;
  max-width: 440px;
  font-family: var(--token-font-body);
  font-size: 15px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.94);
}

.code {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.18);
  font-family: var(--token-font-mono, ui-monospace, SFMono-Regular, Menlo, monospace);
  font-size: 0.92em;
  color: #fefdf6;
}

.steps {
  list-style: none;
  margin: 0 auto;
  padding: 0;
  max-width: 440px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: left;
  font-family: var(--token-font-body);
  font-size: 15px;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.94);
}

.steps li {
  position: relative;
  padding-left: 28px;
}

.steps li::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 0.5em;
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: var(--token-accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--token-accent) 25%, transparent);
}

.fineprint {
  margin: 22px 0 0;
  font-family: var(--token-font-ui);
  font-size: 12px;
  letter-spacing: 0.2px;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.45;
}

@media (max-width: 480px) {
  .card {
    padding: 28px 22px 22px;
    border-radius: 24px;
  }
  .mascot {
    margin-bottom: -22px;
  }
}
